import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { AdminUserComponent } from '../admin-user/admin-user.component';
import { ODuserComponent } from '../oduser/oduser.component';
import { SettingComponent } from '../setting/setting.component';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {

  headerTitle;
  pathname; activeclass;
  Locationone: boolean;
  LocationMulti: boolean;
  constructor(private location: Location, private router: Router, route: ActivatedRoute) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (route.snapshot.firstChild && route.snapshot.firstChild.data['title']) {
          this.headerTitle = route.snapshot.firstChild.data['title'];
          this.pathname = route.snapshot.firstChild.data['title'] ? route.snapshot.firstChild.data['title'] : 'Home';
        } else {
          this.headerTitle = route.snapshot.data['title'];
         this.pathname = this.headerTitle;
        }
      }
    });
  }

  ngOnInit() {
    this.activeclass = "3";
    this.onelocation();
    if(sessionStorage.siginType == 'a'){
      this.activeclass = "2";
    }
  }

  onelocation() {
    if (sessionStorage.siginType == 'a') {
      this.Locationone = true;
      this.LocationMulti = false;
    }
    else {
      this.Locationone = false;
      this.LocationMulti = true;
    }
  }
  back() {
    this.location.back();
  }
  home() {
    this.router.navigate(['/dashboard/OD_User']);

  }

  logout() {
   sessionStorage.setItem('logout','true');
    sessionStorage.clear();
    this.router.navigate(["/authentication"]);
  }
  active(value) {
    //   lakshman
    sessionStorage.removeItem("filterloc");
    //   lakshman
    this.activeclass = value;
  }
}
